export default "__VITE_ASSET__DmvTsB51__"